import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/pl'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import 'element-ui/lib/theme-chalk/index.css'

Sentry.init({
  Vue,
  dsn: "https://12996e7eb1104447966e72bcd1bac9d1@o516580.ingest.sentry.io/4504318735810560",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", "editello.com", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

Vue.config.productionTip = false

Vue.use(Element, { locale })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
